import * as React from 'react';

import { connect } from 'react-redux';

import AppState from '@webapp/store/state';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import DraftMenuItem from './draft-menu-item';
import DraftMenuMerchItem from './draft-menu-merch-item';

import NewMenu from '@components/new-menu';
import Typography from '@components/basics/typography';
import DashboardItemImg, {
  DashboardImage,
} from '@components/dashboard/new-dashboard-item/item-img';
import ArtistListItem from '@components/artist/artist-list-item/index';

import SimpleArtist from '@common/types/artist/simple-artist';

import { activeSummary } from '@webapp/store/release/selectors';
import { ReleaseListSummary } from '@common/types/release/release-list-summary';
import { MerchProduct } from '@services/merch/types/api/merch-product';

interface DraftsMenuProps {
  className?: string;
  artist?: SimpleArtist;
  isMobile?: boolean;
  itemType: 'release' | 'merch';
  images?: DashboardImage[];
  products: MerchProduct[];
  releases: ReleaseListSummary['all'];
}

const mapStateToProps = (state: AppState) => ({
  releases: activeSummary(state),
  artist: state.artist.active,
  isMobile: state.ui.mobile,
  products: state.merch.artistMerch,
});

export const DraftsMenu: React.FC<DraftsMenuProps> = (props) => {
  return props.artist ? (
    <NewMenu
      className={props.className}
      button={props.images ? <DashboardItemImg images={props.images} /> : null}
      menuId={`DRAFTS_MENU-${props.itemType}`}
      topHeader={
        props.isMobile ? (
          <Title>
            <Translate id="DASHBOARD.DRAFT_MENU.TITLE" />
          </Title>
        ) : null
      }
      normalPadding
    >
      {!props.isMobile && props.artist && (
        <StyledArtistListItem
          artist={props.artist}
          noHover
          noIcons
          noTruncate
          hasBigAvatar
        />
      )}
      {!props.isMobile ? (
        <Title>
          <Translate id="DASHBOARD.DRAFT_MENU.TITLE" />
        </Title>
      ) : null}
      {
        <List>
          {props.itemType === 'release' &&
            props.releases?.list
              .filter((release) => release.status === 'draft')
              .sort((a, b) => {
                if (a.previousReleaseDate && b.previousReleaseDate) {
                  return new Date(a.previousReleaseDate) >
                    new Date(b.previousReleaseDate)
                    ? -1
                    : 1;
                }
                return 0;
              })
              .map((release) => (
                <DraftMenuItem
                  artist={props.artist}
                  release={release}
                  key={release.id}
                />
              ))}
          {props.itemType === 'merch' &&
            props.products
              ?.filter((p) => p.status === 'draft')
              .map((product) => (
                <DraftMenuMerchItem product={product} key={product.id} />
              ))}
        </List>
      }
    </NewMenu>
  ) : null;
};

export default connect(mapStateToProps)(DraftsMenu);

const StyledArtistListItem = styled(ArtistListItem)`
  padding: 0;
  margin-bottom: 40px;
`;

const Title = styled(Typography)`
  font-weight: 700;
  font-size: ${({ theme }) => theme.typography.sectionTitle};
  @media ${({ theme }) => theme.device.tablet} {
    margin-bottom: 24px;
    font-size: ${({ theme }) => theme.typography.h4};
  }
`;

const List = styled.div`
  display: grid;
  grid-gap: 20px;
  margin-bottom: 32px;
  @media ${({ theme }) => theme.device.tablet} {
    grid-gap: 16px;
  }
`;
